import RegrasDeNegociacaoDto from '../dto/RegrasDeNegociacaoDto';

export default class RegrasDeNegociacaoResource {
  qtdeMaximaParcelas: number;
  qtdeMinimaParcelas: number;
  valorMinimoParcela: number;
  possuiEntradaDiferenciada: boolean;
  valorMinimoEntrada: number;
  percentualMinimoEntrada: number;
  permiteEntradaMenorQueParcela: boolean;
  permitePropostaMaiorQueValorDivida: boolean;
  diasDisponiveisPagamento: Date[];

  constructor(dto: RegrasDeNegociacaoDto) {
    this.qtdeMaximaParcelas = dto.qtdeMaximaParcelas;
    this.qtdeMinimaParcelas = dto.qtdeMinimaParcelas;
    this.valorMinimoParcela = dto.valorMinimoParcela;
    this.possuiEntradaDiferenciada = dto.possuiEntradaDiferenciada;
    this.valorMinimoEntrada = dto.valorMinimoEntrada;
    this.percentualMinimoEntrada = dto.percentualMinimoEntrada;
    this.permiteEntradaMenorQueParcela = dto.permiteEntradaMenorQueParcela;
    this.permitePropostaMaiorQueValorDivida = dto.permitePropostaMaiorQueValorDivida;
    this.diasDisponiveisPagamento = dto.diasDisponiveisPagamento.map((e) => new Date(e));
  }

  get valorMinimoProposta(): number {
    let valorMinimoProposta = this.valorMinimoEntrada + this.valorMinimoParcela
    * this.qtdeMinimaParcelas;
    /*
      TODO: validar como pegar o valor total da divida, a ideia é
       não ter dependência cíclica como existe na v2
     */
    valorMinimoProposta = Math.min(/* this.divida.valorTotalDivida, */valorMinimoProposta);
    return valorMinimoProposta;
  }

  get permitePagamentoParcelado(): boolean {
    return this.qtdeMaximaParcelas > 1;
  }

  get permitePagamentoAVista(): boolean {
    return this.qtdeMinimaParcelas < 2;
  }
}
